import { Offcanvas, Dropdown } from "bootstrap";
import initExpandCollapse from "./expandCollapse";
import { addAjaxToUrl, getResultsHtml } from "./view-more-ajax-cache-fix";

export default function initFilter() {
  const filterForms = document.querySelectorAll('.js-program-filter')

  filterForms.forEach(filtersForm => {
    const filtersContainer = filtersForm.closest('.tab-pane') || filtersForm.closest('main')
    const resultsContainer = filtersContainer.querySelector('.js-filters-results > ul') || filtersContainer.querySelector('.js-filters-results')

    if (!resultsContainer) return
    const selectedFiltersHolder = filtersForm.querySelector('.js-apply-holder')
    const noFiltersHolder = filtersForm.querySelector('.js-no-apply-holder')

    // Make AJAX request and output response into page.
    async function fetchData(callback) {
      if (resultsContainer.tagName === 'UL') {
        resultsContainer.parentNode.classList.add('loading')
      } else {
        resultsContainer.classList.add('loading')
      }

      const formData = new FormData(filtersForm)

      let ajaxUrl = '';
      let ajaxParams = '';
      // relying on UL here caused biz-3768
      if (resultsContainer.parentNode.classList.contains('program-list')) {
        formData.set('_ajax_nonce', themeAjax.nonce)
        formData.set('action', 'theme_program_filter')

        ajaxUrl = themeAjax.url;
        ajaxParams = {method: 'POST', body: formData};
      } else {
        ajaxUrl = filtersForm.getAttribute('action');
        ajaxParams = {
          method: 'GET',
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        let unifyingSymbol = '?';
        for (const pair of formData.entries()) {
          ajaxUrl += unifyingSymbol;
          ajaxUrl += `${pair[0]}=${pair[1]}`;
          unifyingSymbol = '&';
        }
      }

      const response = await fetch(ajaxUrl, ajaxParams);
      const responseTxt = await response.text();

      if (callback && typeof callback === 'function') {
        callback(responseTxt)
      }

      if (resultsContainer.parentNode.classList.contains('program-list')) {
        resultsContainer.parentNode.classList.remove('loading')
      } else {
        resultsContainer.classList.remove('loading')
      }
    }

    async function fetchMoreData(callback, url) {
      if (resultsContainer.parentNode.classList.contains('program-list')) {
        resultsContainer.parentNode.classList.add('loading')
      } else {
        resultsContainer.classList.add('loading')
      }

      const formData = new FormData(filtersForm)
      formData.set('_ajax_nonce', themeAjax.nonce)
      formData.set('action', 'theme_program_filter')

      const response = await fetch(addAjaxToUrl(url), {
        method: 'GET',
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      const responseTxt = await response.text();

      if (callback && typeof callback === 'function') {
        callback(responseTxt)
      }

      if (resultsContainer.parentNode.classList.contains('program-list')) {
        resultsContainer.parentNode.classList.remove('loading')
      } else {
        resultsContainer.classList.remove('loading')
      }

      window.scroll({
        top: window.scrollY + 100,
        left: 0,
        behavior: "smooth",
      })
    }

    if (selectedFiltersHolder) {
      // Attach 'click' listener to filters panel.
      selectedFiltersHolder.addEventListener('click', e => {
        if (e.target.tagName === 'BUTTON') {
          if (e.target.classList.contains('js-filters-clear')) {
            const selectedFilters = selectedFiltersHolder.querySelectorAll('[data-filter]')
            const personBtn = selectedFiltersHolder.querySelector(`[data-person]`)

            selectedFilters.forEach(item => {
              item.parentNode.remove()

              clearSelectedFilter(item.getAttribute('data-filter'))
            })

            if (personBtn) {
              document.querySelector(`[value="${personBtn.getAttribute('data-filter')}"]`).remove()
            }

            fetchData(appendResponse)
            updateUrl()
          } else if (e.target.getAttribute('data-filter') !== null) {
            e.target.parentNode.remove()

            if (e.target.getAttribute('data-person') !== null) {
              document.querySelector(`[value="${e.target.getAttribute('data-filter')}"]`).remove()
            }

            clearSelectedFilter(e.target.getAttribute('data-filter'))
            fetchData(appendResponse)
            updateUrl()
          }
        }

        toggleSelectedFiltersPanel()
      })

      personFilter()
      // Selected filters panel, set initial state on page load.
      toggleSelectedFiltersPanel()
    }

    // Returns true if holder contains particular selectors or false if not.
    function isFiltersSelected(holder, selector) {
      return holder.querySelectorAll(selector).length > 0
    }

    // Returns filter button html template as string.
    function createBtnFilter(val, id) {
      return `<dd><button type="button" class="js-filters-selected" data-filter="${id}"><i class="fa-sharp fa-solid fa-xmark"></i> <strong>${val}</strong></button></dd>`
    }

    // Return array of all selected filters.
    function getSelectedFilters() {
      let cureSelectedFilters = []
      const allFilters = filtersForm.querySelectorAll('input[type="checkbox"]')
      const searchInput = filtersForm.querySelector('input[type="search"]')

      allFilters.forEach(curFilter => {
        if (curFilter.checked) {
          cureSelectedFilters.push(curFilter)
        }
      })

      if (searchInput && searchInput.value.length) {
        cureSelectedFilters.push(searchInput)
      }

      return cureSelectedFilters
    }

    // Append selected filters labels to the filters panel.
    function addFilterLabel(filters) {
      filters.forEach(filter => {
        let newBtn;

        if (filter.getAttribute('type')) {
          if (filter.getAttribute('type') ===  'search') {
            newBtn = createBtnFilter(filter.value, filter.getAttribute('id'))
          } else if (filter.getAttribute('type') ===  'checkbox') {
            newBtn = createBtnFilter(filter.getAttribute('data-label'), filter.getAttribute('id'))
          }

          selectedFiltersHolder.querySelector('dt').insertAdjacentHTML('afterend', newBtn)
        }
      })

      toggleSelectedFiltersPanel()
    }

    // Clear value from search field or clear checked state from particular checkbox.
    function clearSelectedFilter(id) {
      const selectedFilters = getSelectedFilters()

      selectedFilters.forEach((selectedFilter, index) => {
        if (selectedFilter.getAttribute('id') === id) {
          if (selectedFilter.getAttribute('type') !== null) {
            if (selectedFilter.getAttribute('type') === 'search') {
              clearInputSearch()
            } else if (selectedFilter.getAttribute('type') === 'checkbox') {
              selectedFilter.checked = false
            }

            selectedFilters.splice(index, 1)
          }
        }
      })
    }

    // Clear input search value.
    function clearInputSearch() {
      const inputSearch = filtersForm.querySelector('input[type="search"]')

      if (inputSearch) {
        inputSearch.value = ''
      }
    }

    // Toggle 'd-none' class on filters panel.
    function toggleSelectedFiltersPanel() {
      const noFilterBlocks = filtersContainer.querySelectorAll('.js-no-filter-block');

      if (isFiltersSelected(selectedFiltersHolder, '[data-filter]')) {
        selectedFiltersHolder.classList.remove('d-none');
        noFiltersHolder.classList.add('d-none');
        noFilterBlocks.forEach(item => {
          item.classList.add('d-none')
        })
      } else {
        selectedFiltersHolder.classList.add('d-none');
        noFiltersHolder.classList.remove('d-none');
        noFilterBlocks.forEach(item => {
          item.classList.remove('d-none')
        })
      }
    }

    // Update URL with search query.
    function updateUrl(url) {
      const formData = new FormData(filtersForm)
      const params = new URLSearchParams(formData).toString()

      if(url){
        //window.history.replaceState(null, null, url);
      } else {
        window.history.replaceState(null, null, `?${params}`);
      }
    }

    function clearFiltersHolder() {
      const selectedFilters = selectedFiltersHolder.querySelectorAll('[data-filter]')
      selectedFilters.forEach(item => {
        item.parentNode.remove()
      })
    }

    // Append AJAX response into page.
    function appendResponse(data) {
      resultsContainer.innerHTML = ''
      resultsContainer.insertAdjacentHTML('afterbegin', getResultsHtml(data));
      initExpandCollapse();
    }

    // Append AJAX response into page.
    function appendMore(data) {
      const curLoadMore = resultsContainer.querySelector('.js-filters-load-more')
      if (curLoadMore) curLoadMore.remove()
      resultsContainer.insertAdjacentHTML('beforeend', getResultsHtml(data));
      initExpandCollapse();
    }

    // Close dropdown.
    function closeParentDropdown(el) {
      const filtersDropdown = el.closest('.dropdown');

      if (filtersDropdown) {
        const dropdown = Dropdown.getInstance(filtersDropdown.querySelector('[data-bs-toggle="dropdown"]'))
        dropdown.hide();
      }
    }

    // Close offcanvas with filters on mobile.
    function closeClosestOffcanvas(el) {
      const filtersOffcanvas = el.closest('#filters-wrapper');

      if (filtersOffcanvas) {
        const offcanvas = Offcanvas.getInstance(filtersOffcanvas)
        offcanvas.hide();
      }
    }

    // Account for the person filter.
    function personFilter() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      if (params.get('person_id')) {
        const personID = params.get('person_id')
        const name = document.querySelector(`[value="${personID}"]`).getAttribute('data-creator')
        const newBtn = createBtnFilter(name, personID)

        selectedFiltersHolder.querySelector('dt').insertAdjacentHTML('afterend', newBtn)

        const personBtn = selectedFiltersHolder.querySelector(`[data-filter="${personID}"]`)
        personBtn.setAttribute('data-person', personID)
      }
    }

    // Attach 'click' events listener to the filters form.
    filtersForm.addEventListener('click', e => {
      if (e.target.getAttribute('data-type') !== null) {
        const type = e.target.getAttribute('data-type')
        const holder = e.target.closest('.dropdown-menu')

        if (type === 'clear') {
          e.preventDefault()

          const checkboxes = holder.querySelectorAll('input[type="checkbox"]')

          checkboxes.forEach(checkbox => {
            checkbox.checked = false
          })

          closeParentDropdown(e.target)
        } else if (type === 'clear-all') {
          e.preventDefault()

          const checkboxes = filtersForm.querySelectorAll('input[type="checkbox"]')

          checkboxes.forEach(checkbox => {
            checkbox.checked = false
          })

          clearInputSearch()
          closeClosestOffcanvas(e.target)
        } else if (type === 'apply') {
          e.preventDefault()

          closeParentDropdown(e.target)
        } else if (type === 'apply-all') {
          e.preventDefault()

          closeClosestOffcanvas(e.target)
        }

        clearFiltersHolder()
        personFilter()
        addFilterLabel(getSelectedFilters())
        fetchData(appendResponse)
        updateUrl()
      }
    })

    // Attach 'submit' events listener to the filters form.
    filtersForm.addEventListener('submit', e => {
      e.preventDefault()

      clearFiltersHolder()
      personFilter()
      addFilterLabel(getSelectedFilters())

      fetchData(appendResponse)
      updateUrl()
    })

    resultsContainer.addEventListener('click', e => {
      if (e.target.getAttribute('data-load-more') !== null) {
        e.preventDefault()

        const linkHref = e.target.getAttribute('href')

        fetchMoreData(appendMore, linkHref)
        updateUrl(linkHref.slice(linkHref.indexOf('?') + 1))
      }
    })

    // Allow for filters in Directory tabs.
    const searchParams= new URLSearchParams(window.location.search)
    const activeTabFilter = searchParams.get("tab")

    if (activeTabFilter) {
      if (window.location.hash !== activeTabFilter) {
        window.location.hash = activeTabFilter
      }
    }

    const tabButtons = document.querySelectorAll('.page-header-tabs button[data-bs-toggle="tab"]');
    tabButtons.forEach(tab => {
      tab.addEventListener('shown.bs.tab', function (e) {
        if (filtersForm.closest(tab.getAttribute('data-bs-target'))) {
          setTimeout(() => {
            let hash = window.location.hash;

            if (hash.length) {
              hash = hash.slice(1)
              const searchParams= new URLSearchParams(window.location.search)
              const activeTabFilter = searchParams.get("tab")

              if (activeTabFilter) {
                if (activeTabFilter !== hash) {
                  searchParams.set('tab', hash);
                  const formTab = document.getElementById(hash)

                  if (formTab) {
                    const curForm = formTab.querySelector('.js-program-filter')

                    clearFiltersHolder()
                    personFilter()
                    addFilterLabel(getSelectedFilters())

                    fetchData(appendResponse)
                    updateUrl()
                    history.replaceState(null, null, `#${hash}`);
                  }
                }
              }
            }
          }, 5)
        }
      });
    });
  })
}
